import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { ControlLabel, FormControl, HelpBlock, Radio } from 'react-bootstrap'

import { FormGroup } from 'internal-components/src/components/Form'

export default function ChurnDetails({ errors, setData, signup }) {
  const radioProps = value => ({
    checked: signup.getIn(['data', 'churn']) === value,
    onChange: () => setData('churn', value),
    name: 'churn',
  })

  return (
    <div className="churnDetails">
      <h4>Connection Churn</h4>

      <FormGroup
        bsSize="large"
        controlId="churn"
        errors={errors}
        errorKey="data[churn]"
      >
        <ControlLabel>What kind of connection will this be?</ControlLabel>

        <Radio {...radioProps('new-connection')}>
          This is a brand new connection
        </Radio>
        <Radio {...radioProps('replace')}>
          I am replacing an existing connection with this connection
        </Radio>
        <Radio {...radioProps('unsure')}>I am unsure</Radio>
      </FormGroup>

      {signup.getIn(['data', 'churn']) === 'replace' && (
        <FormGroup
          bsSize="large"
          controlId="exist"
          errors={errors}
          errorKey="data[churn.exist]"
        >
          <ControlLabel>Existing Connection Detail [AVC number]</ControlLabel>
          <FormControl
            onChange={e => setData('churn.exist', e.target.value)}
            placeholder="Existing Connection Detail"
            type="text"
            value={signup.getIn(['data', 'churn.exist']) || ''}
          />
          <HelpBlock>
            You can find your AVC number in your current provider's bill.
          </HelpBlock>
        </FormGroup>
      )}
    </div>
  )
}

ChurnDetails.propTypes = {
  errors: Ipt.map.isRequired,
  setData: Pt.func.isRequired,
  signup: Ipt.record.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/ServiceDetail/ChurnDetails.jsx